var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYourPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.99979C5.448 1.99979 5 2.44779 5 2.99979V20.9998C5 21.5518 5.448 21.9998 6 21.9998H18C18.552 21.9998 19 21.5518 19 20.9998V8.99979H15C13.343 8.99979 12 7.65679 12 5.99979V1.99979H6ZM14 3.41376L17.586 6.99976H15C14.448 6.99976 14 6.55176 14 5.99976V3.41376ZM3 3C3 1.343 4.343 0 6 0H13C13.265 0 13.52 0.105 13.707 0.293L20.707 7.293C20.895 7.48 21 7.735 21 8V21C21 22.657 19.657 24 18 24H6C4.343 24 3 22.657 3 21V3ZM8 14.0001C8 13.4481 8.448 13.0001 9 13.0001H12C12.552 13.0001 13 13.4481 13 14.0001C13 14.5521 12.552 15.0001 12 15.0001H9C8.448 15.0001 8 14.5521 8 14.0001ZM8 17.9998C8 17.4478 8.448 16.9998 9 16.9998H15C15.552 16.9998 16 17.4478 16 17.9998C16 18.5518 15.552 18.9998 15 18.9998H9C8.448 18.9998 8 18.5518 8 17.9998V17.9998Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourPayments);
export default __webpack_public_path__ + "static/media/YourPayments.66895bc81966fefcca8add489e2e898a.svg";
export { ForwardRef as ReactComponent };